export default __webpack_public_path__ + "static/media/IMG_20191020_174245 - 152_Animesh Pathak-min.aedd66eb.jpg";